export default __webpack_public_path__ + "static/media/RefundSectionUploadTemplate.97ec9132.xlsx";